import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-success',
  templateUrl: './contact-success.component.html',
  styleUrls: ['./contact-success.component.scss']
})
export class ContactSuccessComponent implements OnInit {

  ngOnInit(): void {
  }
}
